module.exports = __webpack_public_path__ + "static/img/partner_1.28c6d65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/par/partner_1.png
// module id = lM3r
// module chunks = 0